module.exports = __webpack_public_path__ + "static/media/travel-6@2x.933e47aa.png";